<template>
    <v-app id="inspire">
      <v-app-bar
        dense
        dark
        :fixed="true"
      >
        <v-spacer />

        <language />
      </v-app-bar>
      <v-container fluid class='main-layout px-0 py-0 login-wrapper'>
        <router-view />
      </v-container>
    </v-app>
</template>

<script>
import Language from '@/components/layout/Language.vue';

export default {
  name: 'AuthLayout',
  components: {
    Language,
  },
};
</script>

<style lang="scss">
.container.main-layout {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
</style>
